import {API_URL} from "@/utils/const/api";


async function verifyUser(token: string) {
    try {
        const response = await fetch(API_URL.USER, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        });

        console.log(token);


        if (!response.ok) {
            console.error('Token verification failed', response.status);
            return null;
        }

        return await response.json();
    } catch (error) {
        console.error('An error occurred while verifying the token', error);
        return null;
    }
}

export { verifyUser };
